import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { InfiniteScroll } from 'element-ui';
import './views/rem.js';
import './views/global.css'; // 引入全局样式
Vue.use(InfiniteScroll) 

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

import axios from 'axios';

axios.interceptors.request.use(config => {
  // 检查当前请求是否是登录请求
  if (!config.url.includes('/login')) {  // 根据你的登录接口路径修改判断条件
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    }
  }
  return config; // 别忘了返回配置
}, error => {
  return Promise.reject(error);
});

